import React from 'react';
import PropTypes from 'prop-types';
import { ROUTE_PATH, ROUTE_NAME } from 'utils/constants/router';
import { formRoutePath } from 'functions/formRoutePath';
import styles from './clinicalTrialAnalyticalAnswerMsg.module.css';

export const ClinicalTrialAnalyticalAnswerMsg = ({ content }) => {
  const { text, relatedTrialNct } = content;

  const clinicalTrialsGovUrl = relatedTrialNct
    ? `https://clinicaltrials.gov/study/${encodeURIComponent(relatedTrialNct)}`
    : null;

  const trialRoutePath = relatedTrialNct
    ? formRoutePath(ROUTE_PATH[ROUTE_NAME.TRIAL], { nctNumber: encodeURIComponent(relatedTrialNct) })
    : null;

  const paragraphs = text.split(/\n\n+/).map((paragraph) => paragraph.trim()).filter(Boolean);

  return (
    <div className={styles.card}>
      {paragraphs.length ? (
        <div className={styles.bodyText}>
          {paragraphs.map((p, idx) => (
            <p key={idx} className={styles.paragraph}>{p}</p>
          ))}
        </div>
      ) : (
        <p className={styles.paragraph}>{text}</p>
      )}

      {trialRoutePath ? (
        <div className={styles.linksRow}>
          <span className={styles.relatedLabel}>Related trial:</span>
          <a
            href={trialRoutePath}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
          >
            {`NCT ${trialRoutePath}`}
          </a>
          {clinicalTrialsGovUrl ? (
            <a
              href={clinicalTrialsGovUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.secondaryLink}
            >
              View on ClinicalTrials.gov
            </a>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

ClinicalTrialAnalyticalAnswerMsg.propTypes = {
  content: PropTypes.shape({
    text: PropTypes.string.isRequired,
    relatedTrialNct: PropTypes.string,
  }).isRequired,
};
